import React from 'react';
import classnames from 'classnames';
import { uaParser } from '@betgames/bg-tools';
import { ChevronIcon, ChevronDirection } from 'twain-sport-fe-mono';
import classes from './ScrollToTop.scss';

const SCROLL_OFFSET = 100;

export const ScrollToTop: React.FC = () => {
    const [visible, setVisible] = React.useState(false);

    const handleScroll = () => {
        const nextState = SCROLL_OFFSET < document.documentElement.scrollTop;

        if (nextState !== visible) {
            setVisible(nextState);
        }
    };

    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [visible]);

    const scrollTop = () => {
        // ios 15 returns false positive on scrollTo support and causes the polyfill to fail
        const isIOS15 = uaParser.isIOS && Number(uaParser?.browser.version) >= 15;
        window.scrollTo({ top: 0, behavior: isIOS15 ? 'auto' : 'smooth' });
    };

    return (
        <button
            type="button"
            onClick={scrollTop}
            className={classnames(classes.button, {
                [classes.visible]: visible,
            })}
        >
            <ChevronIcon className={classes.icon} direction={ChevronDirection.UP} />
        </button>
    );
};
